(() => {
  const PROP_KEY = "_unique";
  const INPUT_NAME = `properties[${PROP_KEY}]`;

  const originalFetch = window.fetch.bind(window);

  const token = () =>
    (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const isPost = (options) => ((options?.method || "GET").toUpperCase() === "POST");

  const getUrl = (resource) => (typeof resource === "string" ? resource : resource?.url || "");
  const isCartAdd = (url) => url.includes("/cart/add");
  const isCartChange = (url) => url.includes("/cart/change") || url.includes("/cart/update");

  function cloneFormDataWithUnique(fd) {
    const newFd = new FormData();
    for (const [k, v] of fd.entries()) {
      if (k === INPUT_NAME) continue;
      newFd.append(k, v);
    }
    newFd.append(INPUT_NAME, token());
    return newFd;
  }

  async function getVariantIdFromLine(line) {
    const res = await originalFetch("/cart.js", { headers: { Accept: "application/json" } });
    const cart = await res.json();
    const item = cart?.items?.[line - 1];
    return item?.id || null; // variant id
  }

  async function addDuplicate(variantId) {
    const fd = new FormData();
    fd.append("id", String(variantId));
    fd.append("quantity", "1");
    fd.append(INPUT_NAME, token());

    // Pas besoin de sections ici : on forcera un refresh via /cart/change à la fin
    await originalFetch("/cart/add.js", { method: "POST", body: fd });
  }

  // 1) Form submit /cart/add (sécurité)
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes("/cart/add")) return;

      let input = form.querySelector(`input[name="${INPUT_NAME}"]`);
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = INPUT_NAME;
        form.appendChild(input);
      }
      input.value = token();
    },
    true
  );

  // 2) Interception fetch (cart/add + cart/change)
  window.fetch = async (resource, options = {}) => {
    const url = getUrl(resource);

    // A) /cart/add : on force une property unique à chaque ajout
    if (isPost(options) && isCartAdd(url) && options.body) {
      if (options.body instanceof FormData) {
        options.body = cloneFormDataWithUnique(options.body);
        return originalFetch(resource, options);
      }

      // JSON body (au cas où)
      if (typeof options.body === "string") {
        try {
          const headers = options.headers;
          const ct =
            (headers?.get && headers.get("Content-Type")) ||
            headers?.["Content-Type"] ||
            headers?.["content-type"] ||
            "";
          if (ct.includes("application/json")) {
            const data = JSON.parse(options.body);
            const t = token();

            if (Array.isArray(data.items)) {
              data.items = data.items.map((it) => ({
                ...it,
                properties: { ...(it.properties || {}), [PROP_KEY]: t },
              }));
            } else {
              data.properties = { ...(data.properties || {}), [PROP_KEY]: t };
            }

            options.body = JSON.stringify(data);
          }
        } catch (e) {}
      }

      return originalFetch(resource, options);
    }

    // B) /cart/change : si quelqu’un essaye de mettre quantity > 1, on DUPLIQUE à la place
    if (isPost(options) && isCartChange(url) && typeof options.body === "string") {
      try {
        const data = JSON.parse(options.body);

        const line = Number(data.line);
        const qty = Number(data.quantity);

        // On laisse passer les quantités 0 ou 1 (supprimer / garder)
        if (!line || !Number.isFinite(qty) || qty <= 1) {
          return originalFetch(resource, options);
        }

        // qty > 1 => on transforme en duplication
        const variantId = await getVariantIdFromLine(line);
        if (!variantId) return originalFetch(resource, options);

        const extra = qty - 1;

        // 1) on force la ligne à 1
        const bodySetOne = { ...data, quantity: 1 };
        await originalFetch(resource, { ...options, body: JSON.stringify(bodySetOne) });

        // 2) on ajoute (qty-1) duplicatas
        for (let i = 0; i < extra; i++) {
          await addDuplicate(variantId);
        }

        // 3) on renvoie une réponse /cart/change “finale” avec sections à jour
        // (pour que le drawer se mette à jour correctement)
        return originalFetch(resource, { ...options, body: JSON.stringify(bodySetOne) });
      } catch (e) {
        return originalFetch(resource, options);
      }
    }

    return originalFetch(resource, options);
  };
})();
